import { Autocomplete, Icon, InputBase, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Project } from "../../entities/project";
import { useKronosProjects } from "../../../redux/kronos/kronosHooks";

/**
 * @param {projectAutocompleteProps} projectAutocompleteProps PriorityLevel object from API
 * @returns {ReactElement} Project Autocomplete
 */
export function ProjectAutocomplete({
  projectID,
  onChange,
  variant,
  size,
  helperText,
  disabled,
  autoFocus,
}: projectAutocompleteProps) {
  const [inputValue, setInputValue] = useState("");
  const { projects } = useKronosProjects();
  const project = projects.find((p) => p.id === projectID);

  useEffect(() => {
    if (project) {
      setInputValue(`${project.name}`);
    }
  }, [project]);

  return (
    <Autocomplete
      value={project ?? null}
      onChange={(_e, newValue) => {
        onChange(newValue);
      }}
      disabled={disabled}
      inputValue={inputValue}
      onInputChange={(_e, newInputValue) => {
        setInputValue(newInputValue);
      }}
      size={size}
      getOptionLabel={(option) => `${option.name}`}
      options={projects}
      clearIcon={<Icon sx={{ fontSize: 15 }} className="fa-solid fa-xmark" />}
      renderInput={(params) =>
        variant === "inputBase" ? (
          <div ref={params.InputProps.ref}>
            <InputBase
              inputProps={{ ...params.inputProps }}
              fullWidth
              sx={{ fontSize: 14 }}
              placeholder="Select a project..."
              autoFocus={autoFocus}
            />
          </div>
        ) : (
          <TextField
            variant={variant}
            {...params}
            fullWidth
            sx={{ fontSize: 14 }}
            placeholder="Select a project..."
            autoFocus={autoFocus}
            label="Project"
            helperText={helperText}
          />
        )
      }
    />
  );
}

type projectAutocompleteProps = {
  projectID?: number;
  onChange: (project: Project | null) => void;
  variant?: "standard" | "filled" | "outlined" | "inputBase" | undefined;
  size?: "small" | "medium" | undefined;
  helperText?: string;
  disabled?: boolean;
  autoFocus?: boolean;
};
